import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface HomeResumo {
  totalColaboradores: number;
  totalOnline: number;
  totalAusente: number;
  totalOffline: number;
}

@Injectable({ providedIn: 'root' })
export class HomeApiService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  obterResumo(): Observable<HomeResumo> {
    // Path Node dedicado 2026-07-24 — matching contrato Java byte-a-byte
    // ({totalColaboradores, totalOnline, totalAusente, totalOffline}).
    // Backend pode incluir campos adicionais (ex: breakdownDispositivos) —
    // ignorados no front até que sejam consumidos por alguma view.
    return this.http.get<HomeResumo>(`${this.baseUrl}/api/v1/colaboradores/home/resumo`);
  }
}
